// Toast.js
import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const Toast = ({ message, show, onClose }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000); // Toast disappears after 3 seconds
      return () => clearTimeout(timer); // Cleanup the timer
    }
  }, [show, onClose]);
  
  const success = "fixed z-40 bg-green-500 border-[1px] border-green-600 text-white bottom-5 py-2 px-4 rounded-lg shadow-lg";
  const failure = "fixed z-40 bg-red-500 border-[1px] border-red-600 text-white font-medium bottom-5  py-2 px-4 rounded-lg shadow-lg";

  return (
    <AnimatePresence mode='wait'>
    {show && (
     
      <motion.div
        className={message==="Your message has been sent successfully!" ?  success : failure}
        initial={{ opacity: 0 ,y:50 }}
        animate={{ opacity: 1 , y:0}}
        exit={{ opacity: 0 , y:50 }}
        transition={{type:"spring",duration:0.5 }}
      >
        {message}
      </motion.div>
    
    )}
    </AnimatePresence>
  );
};

export default Toast;
